import {TicketWithFormattedSalePeriod} from '@wix/events-types'
import React from 'react'
import {TicketDescription} from '../../../fields/ticket-description'
import {TicketType} from '../../../fields/ticket-type'
import {SaleEndsLabel} from '../../../fields/sale-ends-label'
import s from './ticket-info-section.scss'

export const TicketInfoSection = ({ticket}: {ticket: TicketWithFormattedSalePeriod}) => {
  return (
    <>
      <TicketType ticket={ticket} />
      <SaleEndsLabel ticket={ticket} className={s.saleEnds} />
      <TicketDescription ticket={ticket} className={s.description} />
    </>
  )
}
